import { RoadsideAssistanceSlice } from "./roadside-assistance-slice";

export { getRoadsideAssistanceThunk ,getRoadsideAssistanceByFilter} from "slices/services/road-side-assistance/roadside-assistance-thunks";

export default RoadsideAssistanceSlice.reducer;

export const { setCurrentPageReducer } = RoadsideAssistanceSlice.actions;
